import * as React from 'react';

import Icon from './Icon';

const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/product`);

export default class Selectbox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.defaultValue,
    };
    this.handleChange = this.handleChange.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
  }

  handleChange(event) {
    this.setState(
      {
        value: event.target.value,
      },
      () => {
        this.props.onChange(this.state.value);
      }
    );
  }

  renderOptions() {
    const { options, value } = this.props;
    if (value === '' && options.length > 0 && options[0].value !== '') {
      options.splice(0, 0, {
        label: $ST.CHOOSE,
        value: '',
      });
    }
    return options.map((option, index) => {
      return (
        <option value={option.value} key={index}>
          {option.label}
        </option>
      );
    });
  }

  render() {
    let { name, icon, classes, value, defaultValue } = this.props;
    return (
      <div className={'selectbox pointer ' + (classes ? classes : '')}>
        <select
          className='pointer'
          onChange={this.handleChange}
          name={name}
          value={value ? value : ''}
          defaultValue={defaultValue}
        >
          {this.renderOptions()}
        </select>
        <Icon icon={icon} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/Selectbox.js